/** Multi-deal registry — RedOaks + Energy Advisors deals (extensible). Metadata only; no CA numbers. */
export default {
  version: 1,
  defaultDealId: 'eagle-etx-2026',
  deals: [
    {
      dealId: 'eagle-etx-2026',
      states: ['TX'], operated: true,
      label: 'Eagle East TX',
      shortLabel: 'Eagle',
      mark: 'ETX',
      subtitle: 'Operated gas · Robertson / Limestone · RedOaks',
      packageName: 'ETXENERGY, LLC — East Texas Operated Divestiture',
      seller: 'ETXENERGY, LLC (Eagle)',
      advisor: 'RedOaks Energy Advisors',
      commodity: 'gas',
      primaryProduct: 'gas',
      legacyFlat: true,
      dataPrefix: '',
      extractDir: 'scripts',
      hostExtractRel: 'deal-package.json',
      bidsDueLabel: 'Aug 5, 2026 · noon CT',
      footerEntity: 'ETXENERGY, LLC (Eagle)',
      footerPackage: 'East Texas Operated Divestiture',
    },
    {
      dealId: 'juno-wtx-2026',
      states: ['TX'], operated: true,
      label: 'Juno West TX',
      shortLabel: 'Juno',
      mark: 'JNO',
      counties: ['Crosby', 'Lubbock'],
      mapCenter: { lat: 33.6, lng: -101.3 },
      subtitle: 'Operated oil · Clear Fork · Crosby / Lubbock · RedOaks',
      packageName: 'RedOaks / Juno Energy West Texas operated package',
      seller: 'Juno Operating III',
      advisor: 'RedOaks Energy Advisors',
      commodity: 'oil',
      primaryProduct: 'oil',
      legacyFlat: false,
      dataPrefix: 'juno-wtx-2026',
      extractDir: 'scripts/deals/juno-wtx-2026',
      hostExtractRel: 'juno-wtx-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Juno Operating III',
      footerPackage: 'RedOaks Juno West Texas',
    },
    {
      dealId: 'sedgwick-cks-2026',
      states: ['KS'], operated: true,
      label: 'Sedgwick Basin Central KS',
      shortLabel: 'Sedgwick',
      mark: 'SDG',
      region: 'Central Kansas',
      mapCenter: { lat: 37.95, lng: -97.9 },
      subtitle: 'Prairie Wolf operated · oil + gas + NGL · Central Kansas',
      packageName: 'Sedgwick Basin / Central Kansas — Prairie Wolf operated',
      seller: 'Prairie Wolf Operating',
      advisor: 'RedOaks Energy Advisors',
      commodity: 'oil+gas+ngl',
      primaryProduct: 'oil',
      products: ['oil', 'casinghead_gas', 'residue_gas'],
      legacyFlat: false,
      dataPrefix: 'sedgwick-cks-2026',
      extractDir: 'scripts/deals/sedgwick-cks-2026',
      hostExtractRel: 'sedgwick-cks-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Prairie Wolf Operating',
      footerPackage: 'Sedgwick Basin Central KS',
    },
    {
      dealId: 'murfin-midcon-2026',
      states: ['KS', 'NE', 'CO', 'OK'], operated: false,
      label: 'Murfin Midcontinent',
      shortLabel: 'Midcon',
      mark: 'MFN',
      region: 'Midcontinent (KS / NE / CO / OK)',
      mapCenter: { lat: 39.0, lng: -99.5 },
      subtitle: 'Non-op oil + gas · KS / NE / CO / OK · Energy Advisors',
      packageName: 'Midcontinent Sale Package — Murfin non-op',
      seller: 'Murfin Drilling Company',
      advisor: 'Energy Advisors',
      commodity: 'oil+gas',
      primaryProduct: 'oil',
      dealKind: 'pdp',
      legacyFlat: false,
      dataPrefix: 'murfin-midcon-2026',
      extractDir: 'scripts/deals/murfin-midcon-2026',
      hostExtractRel: 'murfin-midcon-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Murfin Drilling Company',
      footerPackage: 'Midcontinent Sale Package',
    },
    {
      dealId: 'oei-delaware-2026',
      states: ['NM'], operated: false,
      label: 'OEI Delaware Basin NM',
      shortLabel: 'Delaware',
      mark: 'OEI',
      region: 'Southeast New Mexico',
      mapCenter: { lat: 32.8, lng: -104.0 },
      subtitle: 'Non-op oil · Eddy / Lea NM · Energy Advisors',
      packageName: 'Delaware Basin Sale Package — OEI VI non-op',
      seller: 'OEI VI',
      advisor: 'Energy Advisors',
      commodity: 'oil+gas',
      primaryProduct: 'oil',
      dealKind: 'pdp',
      legacyFlat: false,
      dataPrefix: 'oei-delaware-2026',
      extractDir: 'scripts/deals/oei-delaware-2026',
      hostExtractRel: 'oei-delaware-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'OEI VI',
      footerPackage: 'Delaware Basin Sale Package',
    },
    {
      dealId: 'walkabout-dawson-2026',
      states: ['TX'], operated: true,
      label: 'Walkabout Dawson Co TX',
      shortLabel: 'Dawson',
      mark: 'WLK',
      region: 'Permian (Northern Midland Basin)',
      mapCenter: { lat: 32.74, lng: -101.95 },
      subtitle: 'Operated oil · Dawson Co., TX · Energy Advisors',
      packageName: 'Dawson Co., TX Sale Package — Walkabout operated',
      seller: 'Walkabout Operating, LLC',
      advisor: 'Energy Advisors',
      commodity: 'oil',
      primaryProduct: 'oil',
      dealKind: 'pdp',
      legacyFlat: false,
      dataPrefix: 'walkabout-dawson-2026',
      extractDir: 'scripts/deals/walkabout-dawson-2026',
      hostExtractRel: 'walkabout-dawson-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Walkabout Operating, LLC',
      footerPackage: 'Dawson Co., TX Sale Package',
    },
    {
      dealId: 'mountainv-ky-2026',
      states: ['KY'], operated: true,
      label: 'Mountain V Western KY',
      shortLabel: 'Mountain V',
      mark: 'MTV',
      region: 'Western Kentucky (Illinois Basin)',
      mapCenter: { lat: 37.0, lng: -87.5 },
      subtitle: '156 operated wells · 7-county Western KY · Energy Advisors',
      packageName: '156 Operated Wells; 7-County Sale — Mountain V',
      seller: 'Mountain V',
      advisor: 'Energy Advisors',
      commodity: 'oil',
      primaryProduct: 'oil',
      dealKind: 'pdp',
      legacyFlat: false,
      dataPrefix: 'mountainv-ky-2026',
      extractDir: 'scripts/deals/mountainv-ky-2026',
      hostExtractRel: 'mountainv-ky-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Mountain V',
      footerPackage: '156 Operated Wells; 7-County Sale',
    },
    {
      dealId: 'redtail-cochran-hockley-2026',
      states: ['TX'], operated: true,
      label: 'Red Tail Exploration – Sub Pkg 2',
      shortLabel: 'Red Tail',
      mark: 'RTX',
      region: 'Permian (Northwest Shelf — Levelland San Andres)',
      mapCenter: { lat: 33.62, lng: -102.55 },
      subtitle: '8 wells (7 active, 1 SWD) · Cochran & Hockley Cos., TX · Energy Advisors',
      packageName: 'Sub Pkg 2 — Red Tail Exploration (Bee Jay), Levelland San Andres',
      seller: 'Red Tail Exploration, LLC',
      advisor: 'Energy Advisors',
      commodity: 'oil',
      primaryProduct: 'oil',
      dealKind: 'pdp',
      status: 'Producing',
      legacyFlat: false,
      dataPrefix: 'redtail-cochran-hockley-2026',
      extractDir: 'scripts/deals/redtail-cochran-hockley-2026',
      hostExtractRel: 'redtail-cochran-hockley-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Red Tail Exploration, LLC',
      footerPackage: 'Sub Pkg 2 — Bee Jay',
      listingRef: 'EAG PP 7643DV',
    },
    {
      dealId: 'berexco-crane-2026',
      states: ['TX'], operated: true,
      label: 'Berexco Crane Co TX',
      shortLabel: 'Crane',
      mark: 'BRX',
      region: 'Permian (Central Basin Platform)',
      mapCenter: { lat: 31.4, lng: -102.4 },
      subtitle: 'Teaser only · drilling project · Crane Co., TX · Energy Advisors',
      packageName: 'Crane Co., TX Drilling Project — Berexco',
      seller: 'Berexco',
      advisor: 'Energy Advisors',
      commodity: 'oil',
      primaryProduct: 'oil',
      dealKind: 'teaser',
      legacyFlat: false,
      dataPrefix: 'berexco-crane-2026',
      extractDir: 'scripts/deals/berexco-crane-2026',
      hostExtractRel: 'berexco-crane-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Berexco',
      footerPackage: 'Crane Co., TX Drilling Project',
    },
    {
      dealId: 'goldstone-reeves-2026',
      states: ['TX'], operated: true,
      label: 'Goldstone Reeves Co TX',
      shortLabel: 'Reeves',
      mark: 'GLD',
      region: 'Permian (Southern Delaware Basin)',
      mapCenter: { lat: 31.3, lng: -103.7 },
      subtitle: 'Teaser only · acreage & prospect · Reeves Co., TX · Energy Advisors',
      packageName: 'Reeves Co., TX Acreage & Prospect — Goldstone',
      seller: 'Goldstone',
      advisor: 'Energy Advisors',
      commodity: 'oil+gas',
      primaryProduct: 'oil',
      dealKind: 'teaser',
      legacyFlat: false,
      dataPrefix: 'goldstone-reeves-2026',
      extractDir: 'scripts/deals/goldstone-reeves-2026',
      hostExtractRel: 'goldstone-reeves-2026/deal-package.json',
      bidsDueLabel: null,
      footerEntity: 'Goldstone',
      footerPackage: 'Reeves Co., TX Acreage & Prospect',
    },
  ],
};
